// extracted by mini-css-extract-plugin
export default {"nav":"style_nav__5Lsin","navItem":"style_navItem__7a6US"};